export default {
  computed: {
    gradientStyle() {
      // 渐变色的起始颜色和结束颜色
      const startColor = '#00ADB1';
      const endColor = 'rgba(0,87,89,0.15)';

      // 根据起始颜色和结束颜色创建渐变样式
      const gradient = `linear-gradient(90deg, ${startColor} 0%, ${endColor} 100%)`;

      // 返回包含渐变样式的对象
      return {
        background: gradient
      };
    }
  }
};